(() => {
  const selector = '[data-product-wrapper]';

  function setupProduct(root) {
    if (root.dataset.hpdPreorderReady === 'true') return;

    const form = root.querySelector('[data-product-form]');
    const button = root.querySelector('[data-product-atc]');
    const stockData = root.querySelector('[data-hpd-stock-map]');
    const variantSelection = root.querySelector('[data-variant-selection]');
    const variantInput = root.querySelector('[data-variants]');

    if (!form || !button || !stockData) return;

    let stockMap;
    try {
      stockMap = JSON.parse(stockData.textContent);
    } catch (error) {
      return;
    }

    const preorderIds = new Set(
      stockMap
        .filter((variant) => variant.state === 'preorder')
        .map((variant) => String(variant.id)),
    );
    const states = new Map(
      stockMap.map((variant) => [String(variant.id), variant.state]),
    );
    const propertyInput = form.querySelector('[data-hpd-preorder-property]');
    const deliveryCountdown = root.querySelector('[data-hpd-delivery-countdown]');
    const text = button.querySelector('.atc-button--text');
    const preorderLabel = button.dataset.hpdPreorderLabel || 'Pre-order now';
    const availableLabel = button.dataset.hpdAvailableLabel || 'Add to cart';

    function applyState(variantId) {
      const isPreorder = preorderIds.has(String(variantId));
      form.dataset.hpdPreorderActive = isPreorder ? 'true' : 'false';

      if (isPreorder) {
        button.setAttribute('data-product-atc-preorder', '');
      } else {
        button.removeAttribute('data-product-atc-preorder');
      }

      if (propertyInput) propertyInput.disabled = !isPreorder;
      if (text && !button.disabled) text.textContent = isPreorder ? preorderLabel : availableLabel;
      if (deliveryCountdown) deliveryCountdown.hidden = states.get(String(variantId)) === 'preorder';
    }

    if (variantInput) applyState(variantInput.value);

    if (variantSelection) {
      variantSelection.addEventListener('variant-change', (event) => {
        const variantId = event.detail && event.detail.variant ? event.detail.variant.id : '';
        window.setTimeout(() => applyState(variantId), 0);
      });
    }

    root.dataset.hpdPreorderReady = 'true';
  }

  function setupAll(scope = document) {
    if (scope.matches && scope.matches(selector)) setupProduct(scope);
    scope.querySelectorAll(selector).forEach(setupProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAll());
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
})();
